import { isEmpty } from 'lodash';
import React from 'react';
import { Navigate } from 'react-router-dom';
import GlobalStore from 'stores/globalStore';
import { setItem } from 'utils/local-storage';
import { URL_QUERY_STRING } from 'utils/storage-keys';

function withSession<T>(WrappedComponent: React.ComponentType) {
  const Wrapped: React.FC<T> = (props) => {
    const { session, bootstrap } = GlobalStore.useContainer();

    const search = window.location.search;
    if (search && search.trim() !== '') {
      setItem(URL_QUERY_STRING, search);
    }

    if (!bootstrap && isEmpty(session)) {
      return <Navigate to={`/login?redirect=${window.location.pathname.split('/user')[1]}`} />;
    }

    return <WrappedComponent {...props} />;
  };

  return Wrapped;
}

export default withSession;
